import {
  Group,
  Image,
  Text,
  UnstyledButton,
  useMantineColorScheme,
} from '@mantine/core';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.svg';

import classes from './Logo.module.css';

interface LogoProps {
  to?: string;
  showText?: boolean;
  onClick?: () => void;
  className?: string;
  mini?: boolean;
}

const Logo = ({ to = '/', showText = true, onClick, className, mini }: LogoProps) => {
  const { colorScheme } = useMantineColorScheme();

  return (
    <UnstyledButton
      className={`${classes.logo} ${className || ''}`}
      component={Link}
      to={to}
      onClick={onClick}
      data-mini={mini || undefined}
    >
      <Group gap={mini ? 0 : 'xs'}>
        <Image
          src={logo}
          height={showText ? 32 : 24}
          width={showText ? 32 : 24}
          alt="Interview Pilot logo"
          style={colorScheme === 'light' ? { filter: 'brightness(0) invert(1)' } : {}}
        />
        {showText && !mini && (
          <Text 
            size="xl" 
            fw={700} 
            c={colorScheme === 'dark' ? 'white' : 'navy.7'}
          >
            Interview Pilot
          </Text>
        )}
      </Group>
    </UnstyledButton>
  );
};

export default Logo;